import { EthIcon, UsdtIcon, UsdcIcon } from "@/components/icons";
import { REWARD_SYMBOL } from "@/constants/spinningWheel";

/**
 * Returns true if the symbol represents WETH.
 */
export const isWethSymbol = (symbol: string): boolean => symbol === REWARD_SYMBOL.WETH;

/**
 * Maps a reward symbol to the appropriate CSS color variable used in the UI.
 */
export const getRewardCssVar = (symbol: string): string => {
  if (symbol === REWARD_SYMBOL.WETH) return "--color-eth-primary";
  if (symbol === REWARD_SYMBOL.USDC) return "--color-usdc-primary";
  return "--color-usdt-primary";
};

/**
 * Returns the React icon component for a given reward symbol.
 */
export const getRewardIcon = (symbol: string, props: { width?: number; height?: number; className?: string }) => {
  if (symbol === REWARD_SYMBOL.WETH) return <EthIcon {...props} />;
  if (symbol === REWARD_SYMBOL.USDC) return <UsdcIcon {...props} />;
  return <UsdtIcon {...props} />;
};

/**
 * Returns the appropriate text color class for a given reward symbol.
 */
export const getRewardTextColorClass = (symbol: string): string => {
  if (symbol === REWARD_SYMBOL.WETH) return "text-cede-eth-primary";
  if (symbol === REWARD_SYMBOL.USDC) return "text-cede-usdc-primary";
  return "text-cede-usdt-secondary";
};
